const $ = jQuery;
const $window = $(window);

const initScrollLinks = () => {
  // Scroll to top button.
  const $button = $('.scroll-to-top');
  const $body = $('html, body');

  const onClick = function () {
    const { dataset } = this;
    if (dataset.animating === 'yes') {
      return;
    }
    dataset.animating = 'yes';
    $body.animate(
      {
        scrollTop: 0,
      },
      600,
      'swing',
      function () {
        dataset.animating = '';
      },
    );
  };
  $button.on('click', onClick);
};

$window.on('load', function () {
  initScrollLinks();
});
